<!--
* @FileDescription: 管理后台顶部
* @Author: Rocky
* @Date: 2020-12-25
* @LastEditors: Rocky
* @LastEditTime: 2020-12-25
-->
<template>
  <div id="app-header">
    <el-row>
      <el-col class="app-logo" :span="8">
        <ul style="padding: 0%;margin: 10px 0px;">
          <li>
            <span style="color: #fff; font-size: 24px;">新民入驻企业管理系统</span>
            <br/>
            <span style="color: #fff; font-size: 12px;">New Energy Exhibition Platform Shop</span>
          </li>
        </ul>
      </el-col>
      <el-col class="app-links" :span="12">
        <ul>
          <li v-for="(item, index) in assets.appLinks" :key="index"
          @click="goMain(index)">
            <i :class="item.icon"></i>
            <span>{{ item.text }}</span>
            <span>{{ appLinkData[item.id] }}</span>
          </li>
        </ul>
      </el-col>
      <el-col class="app-btns" :span="2" :offset="2">
        <ul>
          <!-- <li @click="openEditPassword">
            <i class="el-icon-lock"></i>
            <span>修改密码</span>
          </li> -->
          <li @click="logout">
            <i class="el-icon-switch-button"></i>
            <span>退出</span>
          </li>
        </ul>
      </el-col>
    </el-row>

    <!-- 对话框 -->
    <el-dialog title="修改密码" :visible.sync="showEditPassword" :close-on-click-modal="false"
    width="30%" :modal="false" top="30vh" custom-class="app-alert-dialog">
      <el-form :model="formData" label-position="left" label-width="80px">
        <el-form-item label="原密码">
          <el-input size="small" v-model="formData.oriPw" placeholder="原密码"></el-input>
        </el-form-item>
        <el-form-item label="新密码">
          <el-input size="small" v-model="formData.newPw" placeholder="新密码"></el-input>
        </el-form-item>
        <el-form-item label="确认密码">
          <el-input size="small" v-model="formData.rePw" placeholder="确认密码"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showEditPassword = false">取 消</el-button>
        <el-button type="primary" @click="doEditPassword">修 改</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'app-header',
  data () {
    return {
      assets: {
        appLinks: [
          // { id: 'member', icon: 'el-icon-user-solid', text: '注册会员', path: '/user' },
          // { id: 'order', icon: 'el-icon-s-order', text: '今日发布', path: '/order' },
          // { id: 'driver', icon: 'el-icon-s-custom', text: '会员', path: '/driver' },
          // { id: 'waiting', icon: 'el-icon-s-cooperation', text: '活跃度', path: '/order' },
          // { id: 'ongoing', icon: 'el-icon-s-promotion', text: '发帖数', path: '/order' }
        ]
      },
      appLinkData: {
        'member': 100,
        'order': 100,
        'driver': 100,
        'waiting': 100,
        'ongoing': 100
      },
      formData: {
        oriPw: '',
        newPw: '',
        rePw: ''
      },
      showEditPassword: false
    }
  },
  methods: {
    /**
     * 跳转到 Main 中对应链接
     */
    goMain (index) {
      let that = this
      let linkPath = that.assets.appLinks[index].path
      if (linkPath !== this.$route.path) {
        that.$router.replace({
          path: linkPath,
          params: {}
        })
      }
    },
    /**
     * 打开对话框
     */
    openEditPassword () {
      let that = this
      that.showEditPassword = true
    },
    doEditPassword () {
      let that = this
      console.log(that.formData)
    },
    /**
     * 登出
     */
    logout () {
      this.COOKIE.clearCookie('uid')
      location.reload()
    }
  }
}
</script>

<style scoped>
.header-txt{
  font-size: 26px;
  color: white;
  margin-left: 25px;
  margin-top: 10px;
  text-align: center;
}
.app-logo {
  position: relative;
  left: 0px;
  top: -8px;
}
.app-links ul,
.app-btns ul {
  list-style: none;
  padding: 6px;
}
.app-btns li,
.app-links li {
  display: inline-block;
  margin-right: 25px;
  cursor: pointer;
}
.app-links li i {
  font-size: 17px;
  color: #494949;
  position: relative;
  top: 1px;
}
.app-links li span:nth-child(2),
.app-btns li {
  color: #a8a8a8;
}
.app-links li span:last-child {
  color: #a8a8a8;
}
.app-links li:hover span:nth-child(2) {
  color: #deefff;
}
.app-links li:hover i,
.app-links li:hover span:last-child {
  color: #deefff;
}
</style>



// WEBPACK FOOTER //
// src/components/frame/Header.vue